import { useEffect, useState } from 'react'
import { authService } from '../services/authService'
import { isCreditApplicationTerminal } from '../utils/creditApplicationStatus'

interface UseHasCompletedCreditApplicationResult {
  hasCompletedApplication: boolean
  isLoading: boolean
}

// Indica si el usuario tiene al menos una credit application en estatus
// terminal (aprobada o rechazada, ver isCreditApplicationTerminal). Se usa
// para decidir si el sidebar flotante de cuenta (AccountSidebar) tiene
// sentido mostrarse: antes de eso, el usuario no tiene nada que navegar en
// "Mis arrendamientos"/"Mis documentos", así que el menú solo confundiría.
export const useHasCompletedCreditApplication =
  (): UseHasCompletedCreditApplicationResult => {
    const [hasCompletedApplication, setHasCompletedApplication] =
      useState(false)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
      let isMounted = true

      const load = async () => {
        try {
          const creditApps = await authService.getAllCreditApplications()
          if (!isMounted) return
          setHasCompletedApplication(
            creditApps.some(app => isCreditApplicationTerminal(app.status))
          )
        } finally {
          if (isMounted) setIsLoading(false)
        }
      }

      load()

      return () => {
        isMounted = false
      }
    }, [])

    return { hasCompletedApplication, isLoading }
  }
